module.exports = __webpack_public_path__ + "img/logo-boma-tech-app.062df16b.png";